var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("data.bank_account_status"),
            "close-on-click-modal": false,
            width: "509px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeModal,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _vm._l(_vm.approvedList, function (item, index) {
            return _c("div", { key: index, staticClass: "section-title" }, [
              _vm._v(" Your bank account "),
              _c("span", { staticClass: "bank-no" }, [
                _vm._v(
                  _vm._s(
                    item.settlement_bank +
                      " (" +
                      item.settlement_bank_account_num +
                      ") "
                  )
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    "has been " +
                      (item.audit_status === 2 ? "approved" : "rejected") +
                      "."
                  ) +
                  " "
              ),
            ])
          }),
          _vm._l(_vm.rejectedList, function (item, index) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(" Your bank account "),
                _c("span", { staticClass: "bank-no" }, [
                  _vm._v(
                    _vm._s(
                      item.settlement_bank +
                        " (" +
                        item.settlement_bank_account_num +
                        ") "
                    )
                  ),
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      "has been " +
                        (item.audit_status === 2 ? "approved" : "rejected") +
                        "."
                    ) +
                    " "
                ),
              ]),
              item.audit_status === 3
                ? _c("div", { staticClass: "section-tip" }, [
                    _c("span", [_vm._v("Rejection Reason:")]),
                    _c("span", [_vm._v(_vm._s(item.audit_back_reason))]),
                  ])
                : _vm._e(),
            ])
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.proceed")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }